import React, { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import { Accordion, FormElems } from '../../..';
import { UBO_ACCORDIAN_NAME, UBO_CREATE_FORM_NAME, uboFields } from './constant';
import "./uboTab.scss";
import UboActiveField from './UboActiveField';
import UboInputFields from './UboInputFields';
import { getActiveCount, UBO_ACTIVE_FIELDS } from '../mle.utils';
import { toast } from 'react-toastify';
import { ERROR_UBO } from '../mle.constants';
import { MAKER_CHECKER_EVENT_TYPES_MLE } from 'utils/constants/commonValues';

const UboInputs = ({ 
    isViewMode, 
    fields, 
    initialData, 
    actions,
    setIsUploading,
    setSelectedDocument,
    poaOptions,
    activeCount,
    setActiveCount,
    setInvalidSubmit,
    uboFormData,
    intentId,
    checkerRemarks,
    isEditMode,
    setUboAdded,
    infoMsgs,
    uboAdded,
    entityId,
    isReEditFlow,
    setIntentId,
    createdAt,
    setDocTimeStamp,
    eventType,
    dbUBOCount
 }) => {
    const [panNumbers, setPanNumbers] = useState({});
    const addActiveUboField = (fields) => {
        try {
            let initialValue = {};
            initialValue['status'] = UBO_ACTIVE_FIELDS.ACTIVE;
            setUboAdded((prev) => {
                prev.push(`${UBO_ACCORDIAN_NAME}[${fields.length}]`);
                return prev;
            })
            fields.push(initialValue);
        } catch(e) {
            console.log("addActiveUboField error", e);
            toast.error(ERROR_UBO);
        }
    }
    
    useEffect(() => {
        if (fields.length <= 0) {
            // add new ubo
            addActiveUboField(fields);
        }
    }, []);
    
    if (fields.length <= 0) {
        return <></>
    }

    const isOldUbo = ((index) => {
        return eventType === MAKER_CHECKER_EVENT_TYPES_MLE.ownership_update  && dbUBOCount > index
    });

    return (
        <>
            <div className="action-container">
                <div className="align-button action">
                    {!isViewMode && (
                        <FormElems.Button
                            type="button"
                            buttonType="secondary"
                            id="add-field"
                            text={`+ Add UBO`}
                            customClass="add-button"
                            isDisable={getActiveCount(activeCount)}
                            handleClick={() => {
                                addActiveUboField(fields);
                            }}
                        />
                    )}
                </div>
            </div>
            {fields.map((item, index) => {
                // let uboIsActive = fields.get(index)?.[uboFields.uboActive.name(item)] ||  true;
                return (
                    <>
                        <Accordion
                            customClass="rounded-accordion"
                            style={{ margin: '0px' }}
                            isArrowIndicator
                            isOpened={index==0}
                            upperComponent={
                                <>
                                    <div className='mle-upper-according-component'>
                                        <h2 className="accordian-title">
                                            UBO {index + 1} Details
                                        </h2>
                                        <UboActiveField 
                                            // uboIsActive={uboIsActive} 
                                            actions={actions}
                                            item={item}
                                            index={index}
                                            isViewMode={isViewMode}
                                            setActiveCount={setActiveCount}
                                            activeCount={activeCount}
                                            fields={fields}
                                        />
                                    </div>
                                </>
                            }
                            lowerComponent={
                                <>
                                    <UboInputFields
                                        isViewMode={isViewMode}
                                        field={item}
                                        sectionData={fields.get(index)}
                                        actions={actions}
                                        fields={fields}
                                        item={item}
                                        index={index}
                                        setIsUploading={setIsUploading}
                                        setSelectedDocument={setSelectedDocument}
                                        poaOptions={poaOptions}
                                        setActiveCount={setActiveCount}
                                        setInvalidSubmit={setInvalidSubmit}
                                        activeCount={activeCount}
                                        uboFormData={uboFormData}
                                        intentId={intentId}
                                        checkerRemarks={checkerRemarks}
                                        setPanNumbers={setPanNumbers}
                                        panNumbers={panNumbers}
                                        isEditMode={isEditMode && !uboAdded?.includes(item)}
                                        infoMsgs={infoMsgs}
                                        entityId={entityId}
                                        setUboAdded={setUboAdded}
                                        isReEditFlow={isReEditFlow}
                                        setIntentId={setIntentId}
                                        createdAt={createdAt}
                                        setDocTimeStamp={setDocTimeStamp}
                                        clearBtnHide={eventType === MAKER_CHECKER_EVENT_TYPES_MLE.ownership_update && dbUBOCount > index}
                                        eventType={isOldUbo(index) ? eventType : null}
                                    />
                                    
                                </>
                            }
                        />
                    </>
                );
            })}
            
        </>
    );
};



export default UboInputs;
